import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { AssistantFavoriteView, AssistantView } from '../_generated';

export const AssistantFavoritesActions = createActionGroup({
  source: 'AssistantFavorites',
  events: {
    /** Fetch the current user's favorites from the API. */
    Load: emptyProps(),
    'Load Success': props<{ favorites: AssistantFavoriteView[] }>(),
    'Load Failure': props<{ error: string }>(),

    'Add Favorite': props<{ assistantId: string; assistant: AssistantView }>(),
    'Add Favorite Success': props<{
      favorite: AssistantFavoriteView;
      assistant: AssistantView;
    }>(),
    'Add Favorite Failure': props<{ assistantId: string; error: string }>(),

    'Remove Favorite': props<{
      assistantId: string;
      assistant: AssistantView;
    }>(),
    'Remove Favorite Success': props<{
      assistantId: string;
      assistant: AssistantView;
    }>(),
    'Remove Favorite Failure': props<{ error: string }>(),

    'Update Sort Order': props<{
      assistantId: string;
      sortOrder: string;
      previousSortOrder: string;
    }>(),
    'Update Sort Order Success': props<{
      assistantId: string;
      sortOrder: string;
    }>(),
    'Update Sort Order Failure': props<{
      assistantId: string;
      attemptedSortOrder: string;
      previousSortOrder: string;
      error: string;
    }>(),
  },
});
